import React, { useState, useEffect } from 'react';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

const DeviceFingerprint = () => {
    const [visitorId, setVisitorId] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // 1. تهيئة المكتبة
        const setFp = async () => {
            const fp = await FingerprintJS.load();

            // 2. الحصول على البصمة (النتيجة تحتوي على الـ VisitorId)
            const result = await fp.get();

            setVisitorId(result.visitorId);
            setLoading(false);
        };

        setFp();
    }, []);

    return (
        <div style={{ padding: '20px', direction: 'rtl', fontFamily: 'sans-serif' }}>
            <h2>بصمة الجهاز الفريدة</h2>
            <hr />

            {loading ? (
                <p>جاري توليد بصمة الجهاز...</p>
            ) : (
                <div style={{ marginTop: '20px' }}>
                    <p><strong>معرّف الزائر (Visitor ID):</strong></p>
                    <code style={{
                        backgroundColor: '#eee',
                        padding: '10px',
                        display: 'block',
                        wordBreak: 'break-all',
                        borderRadius: '5px'
                    }}>
                        {visitorId}
                    </code>
                </div>
            )}
        </div>
    );
};

export default DeviceFingerprint;